import _styled, { default as _styled2, default as _styled3 } from "styled-components";
const _excluded = ["className", "style", "text", "matched", "highlightStyle"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { escapeRegex } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const HighlightText = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      style,
      text,
      matched,
      highlightStyle
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!text) return null;
  if (!matched) return /*#__PURE__*/React.createElement(_StyledSpan, _extends({
    ref: ref,
    className: className
  }, rest, {
    $_css: [style]
  }), text);
  const keywords = Array.isArray(matched) ? matched : [matched];
  const partials = [...keywords].sort((va, vb) => va.length > vb.length ? -1 : 1).reduce((pre, keyword) => {
    const splitter = new RegExp(`(${escapeRegex(keyword)})`, 'ig');
    return pre.reduce((blocks, block) => {
      if (block.highlight) return [...blocks, block];
      return [...blocks, ...block.word.split(splitter).map(txt => ({
        word: txt,
        highlight: new RegExp(`^${escapeRegex(keyword)}$`, 'i').test(txt)
      }))];
    }, []);
  }, [{
    word: text,
    highlight: false
  }]);
  return /*#__PURE__*/React.createElement(_StyledSpan2, _extends({
    ref: ref,
    className: className
  }, rest, {
    $_css2: [style]
  }), partials.map((partial, index) => /*#__PURE__*/React.createElement(_StyledSpan3, {
    key: index,
    $_css3: partial.highlight ? [{
      backgroundColor: theme.tokens.colors.background.highlight.value
    }, highlightStyle] : undefined
  }, partial.word)));
});
HighlightText.displayName = 'HighlightText';
HighlightText.propTypes = {
  /** The highlighted matched text */
  matched: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string.isRequired)]),
  /** The original text */
  text: PropTypes.string,
  /** Styles applied to root element */
  style: stylePropType,
  /** Styled applied to matched highlight element */
  highlightStyle: stylePropType,
  /** ClassName applied to root element */
  className: PropTypes.string
};
export default HighlightText;
var _StyledSpan = _styled("span")`${p => p.$_css}`;
var _StyledSpan2 = _styled2("span")`${p => p.$_css2}`;
var _StyledSpan3 = _styled3("span").withConfig({
  displayName: "HighlightText___StyledSpan3",
  componentId: "sc-19xfvf5-0"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=HighlightText.js.map